// extracted by mini-css-extract-plugin
export var container = "copyright-module--container---TOsJ";
export var copyright = "copyright-module--copyright--Mgzht";
export var link = "copyright-module--link--rh0vo";
export var mobileCopyright = "copyright-module--mobileCopyright--Iz6Oq";
export var mobileLegal = "copyright-module--mobileLegal--5qnjr";
export var section = "copyright-module--section--IMdXp";
export var show = "copyright-module--show--DhalS";